import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { OpportunitiesModule } from '../core/opportunities.module';
import { Subject } from 'rxjs';
import { appSettings } from '../core/config.module';
import { getUrlComponents } from '../utilities/url';
import { ChildMessagePort } from '../utilities/messaging';
OpportunitiesModule.factory('globalIframeService', ["$logFactory", function ($logFactory) {
  "ngInject";

  return new GlobalIframeService($logFactory.get("globalIframeService"));
}]);

/**
 * A message port that always sends/receives data from the "current"
 * #autoalertiframe.
 *
 * This is necessary because three different components all create an
 * #autoalertiframe element, and they just happen to be mutually exclusive on
 * the page:
 *
 * - aaIframe
 * - legacyIframeSupport
 * - iframeModal
 *
 * Each of these components has coincidentally created an #autoalertiframe when
 * our page is expecting to be able to postMessage to that iframe.
 *
 * THIS IS A BACKWARDS-COMPATIBILITY UTILITY. We should gradually separate "the
 * iframe that is displaying a legacy page" and "the iframe that responds to
 * messages like GET_SSO_ID_TOKEN". We should have a single, hidden,
 * never-destroyed iframe that sends/receives all messages, and our app can
 * expose that one iframe as a service.
 */
var GlobalIframeService = /*#__PURE__*/function () {
  function GlobalIframeService($log) {
    _classCallCheck(this, GlobalIframeService);
    this._$log = $log;
    this._subscriptions = new Subject();
    this._subscriptions.subscribe(function (_ref) {
      var event = _ref.event,
        port = _ref.port;
      return $log.debug("Received", event.data, port);
    });
  }
  return _createClass(GlobalIframeService, [{
    key: "setCurrentMessagePort",
    value: function setCurrentMessagePort(port, $scope) {
      var _this = this;
      this._port = port;
      var onMessageReceived;
      if ($scope) {
        onMessageReceived = function onMessageReceived(event) {
          return $scope.$apply(function () {
            return _this._subscriptions.next({
              event: event,
              port: port
            });
          });
        };
      } else {
        onMessageReceived = function onMessageReceived(event) {
          return _this._subscriptions.next({
            event: event,
            port: port
          });
        };
      }
      this._port.subscribe(onMessageReceived);
    }
  }, {
    key: "postMessage",
    value: function postMessage(data) {
      if (this._port) {
        this._$log.debug("Posting message", data);
        return this._port.postMessage(data);
      } else {
        this._$log.warn("Tried to post a message when no port is available");
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      return this._subscriptions.subscribe({
        next: function next(_ref2) {
          var event = _ref2.event,
            port = _ref2.port;
          return callback(event, port);
        }
      });
    }
  }]);
}();